// 表单中 值属于 table column 的字段名
export const COLUMN_KEYS = ["dimensionId", "calculationTargetId", "stackByColumnId"];

// 编辑页面 右侧 表单宽度 包含 16px 的 padding
export const EDIT_PAGE_FORM_WIDTH = 320;

// 筛选条件数量上限
export const FILTER_COUNT_MAX = 10;
